import { useEffect } from "react";
import { CrewScheduleGL } from "src/pages/CrewSchedule/gl/CrewScheduleGL";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";

interface ISelectedCrewEventsProps {
  crewSchedGL: CrewScheduleGL;
  start: () => void;
  isAnimating: boolean;
}

export const SelectedCrewEvents = (props: ISelectedCrewEventsProps): JSX.Element => {
  const { crewSchedGL, start, isAnimating } = props;

  const selectedCrewEvents = useSelector((state: IRootState) => state.crewSchedule.selectedCrewEvents);

  useEffect(() => {
    if (!crewSchedGL) {
      return;
    }
    crewSchedGL.setOutlinedEvents(selectedCrewEvents);
    if (!isAnimating) {
      start();
    }
  }, [selectedCrewEvents, start, crewSchedGL, isAnimating]);

  return <div></div>;
};
